import {
    Autocomplete,
    Box,
    FormControl,
    Grid,
    InputAdornment,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import NumberFormat from "react-number-format";
import {
    IOptions,
    MutasiValues,
    ParamsGetItem,
    SelectedProductMutasi,
} from "../../../constants/types";
import { useAuth } from "../../../context/authContext";
import useItem from "../../../services/queries/useItem";

interface IBarangTerpilihProps {
    product?: SelectedProductMutasi;
    idx: number;
    methods: UseFormReturn<MutasiValues, object>;
}

const BarangTerpilih = ({ product, idx, methods }: IBarangTerpilihProps) => {
    const watchIsMasuk = methods.watch(`detail.${idx}.isMasuk`);
    const watchStok = methods.watch(`detail.${idx}.jumlahStok`);
    const watchStokRepack = methods.watch(`detail.${idx}.stokRepack`);

    const { ukmIdUser } = useAuth();
    const initialParamsStok: ParamsGetItem = {
        ukmId: ukmIdUser && ukmIdUser[0],
        search: "",
        isShow: 0,
        kategori: "",
        size: 10,
        page: 1,
    };
    const [paramsStok, setParamsStok] = useState(initialParamsStok);
    const { data: stok, isLoading: isLoadingStok } = useItem(paramsStok);
    const mappedStok = stok?.content
        .filter((st) => st.detailBundling.length === 0)
        .map((li) => ({
            id: li.id,
            nama: li.namaBarang,
        }));

    if (!product) return null;

    return (
        <Box>
            <Typography fontWeight="bold">{`${idx + 1}. ${product?.nama} (${
                product?.sku
            })`}</Typography>

            {/* {faktur && ukmData?.isPro === 1 ? (
                <Typography>
                    Jumlah stok pada faktur {faktur.faktur}:{" "}
                    <b>{faktur.jumlah} buah</b>
                </Typography>
            ) : (
                <Typography>{`Jumlah stok saat ini: ${totalStok}`}</Typography>
                )} */}
            <Typography>
                Jumlah stok saat ini: <b>{product?.stok} buah</b> | Harga beli
                average:{" "}
                <b>
                    <i>sedang dibuat...</i>
                </b>
            </Typography>
            <Grid container spacing={1} mt={1}>
                <Grid item xs={12} md={4.5}>
                    <Typography>Pilih mutasi:</Typography>
                    <Controller
                        name={`detail.${idx}.isMasuk`}
                        control={methods.control}
                        render={({ field }) => (
                            <FormControl size="small" fullWidth>
                                <Select
                                    placeholder="Pilih Stok"
                                    margin="dense"
                                    onChange={(event: SelectChangeEvent) => {
                                        field.onChange(
                                            event.target.value as string,
                                        );
                                    }}
                                    value={field.value}
                                    // error={Boolean(
                                    //     errors.kategoriBundling,
                                    // )}
                                >
                                    <MenuItem value="masuk">
                                        Stok Masuk
                                    </MenuItem>
                                    <MenuItem value="keluar">
                                        Stok Keluar
                                    </MenuItem>
                                    <MenuItem value="repack">Repack</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                    />
                </Grid>
                <Grid item xs={6} md={5}>
                    <Typography>Stok dimutasi:</Typography>
                    <Controller
                        name={`detail.${idx}.jumlahStok`}
                        control={methods.control}
                        rules={{
                            required: "Kolom wajib diisi",
                            min: {
                                value: 1,
                                message: "Minimal stok mutasi adalah 1 buah", // JS only: <p>error message</p> TS only support string
                            },
                            max: {
                                value:
                                    watchIsMasuk === "masuk"
                                        ? 999999
                                        : product?.stok
                                        ? product?.stok
                                        : 0,
                                message:
                                    watchIsMasuk === "masuk"
                                        ? "Stok maksimal"
                                        : `Stok maksimal`, // JS only: <p>error message</p> TS only support string
                            },
                        }}
                        render={({ field, fieldState }) => (
                            <TextField
                                type="number"
                                variant="outlined"
                                size="small"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            stok
                                        </InputAdornment>
                                    ),
                                }}
                                onKeyDown={(evt) =>
                                    ["e", "E", "+", "-"].includes(evt.key) &&
                                    evt.preventDefault()
                                }
                                onWheel={(e) => {
                                    const target =
                                        e.target as HTMLButtonElement;
                                    if (target) {
                                        target.blur();
                                        e.stopPropagation();
                                        setTimeout(() => {
                                            target.focus();
                                        }, 0);
                                    }
                                }}
                                inputProps={{
                                    inputMode: "numeric",
                                    style: {
                                        textAlign: "right",
                                    },
                                }}
                                fullWidth
                                error={!!fieldState?.error}
                                helperText={
                                    fieldState?.error &&
                                    fieldState?.error.message
                                }
                                {...field}
                                onChange={(event) => {
                                    if (watchIsMasuk === "repack") {
                                        field.onChange(
                                            Number(event.target.value),
                                        );
                                        const hargaBeli = Math.ceil(
                                            (Number(product?.harga) *
                                                Number(event.target.value)) /
                                                Number(watchStokRepack),
                                        );
                                        methods.setValue(
                                            `detail.${idx}.hargaBeliRepack`,
                                            hargaBeli,
                                        );
                                    } else {
                                        field.onChange(
                                            Number(event.target.value),
                                        );
                                    }
                                }}
                            />
                        )}
                    />
                    <input
                        type="hidden"
                        {...methods.register(`detail.${idx}.itemId`)}
                        value={product?.id}
                    />
                </Grid>
            </Grid>
            {watchIsMasuk === "repack" && (
                <Grid
                    container
                    spacing={1}
                    marginTop={1}
                    alignItems="flex-start"
                >
                    <Grid item xs={6} md={3}>
                        <Typography>Repack menjadi:</Typography>
                        <Controller
                            name={`detail.${idx}.stokRepack`}
                            control={methods.control}
                            rules={{
                                required: "Kolom wajib diisi",
                                min: {
                                    value: 1,
                                    message: "Minimal stok 1 buah", // JS only: <p>error message</p> TS only support string
                                },
                                // max: {
                                //     value: 1000,
                                //     message: `Maksimal stok 1000 buah`, // JS only: <p>error message</p> TS only support string
                                // },
                            }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    type="number"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    onKeyDown={(evt) =>
                                        ["e", "E", "+", "-"].includes(
                                            evt.key,
                                        ) && evt.preventDefault()
                                    }
                                    onWheel={(e) => {
                                        const target =
                                            e.target as HTMLButtonElement;
                                        if (target) {
                                            target.blur();
                                            e.stopPropagation();
                                            setTimeout(() => {
                                                target.focus();
                                            }, 0);
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                stok
                                            </InputAdornment>
                                        ),
                                    }}
                                    inputProps={{
                                        inputMode: "numeric",
                                        style: {
                                            textAlign: "right",
                                        },
                                    }}
                                    error={!!fieldState?.error}
                                    helperText={
                                        fieldState?.error &&
                                        fieldState?.error.message
                                    }
                                    {...field}
                                    onChange={(event) => {
                                        // field.onChange(event);
                                        methods.setValue(
                                            `detail.${idx}.stokRepack`,
                                            event.target.value,
                                        );

                                        const hargaBeli = Math.ceil(
                                            (Number(product?.harga) *
                                                Number(watchStok)) /
                                                Number(event.target.value),
                                        );
                                        methods.setValue(
                                            `detail.${idx}.hargaBeliRepack`,
                                            hargaBeli,
                                        );
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={3.5}>
                        <Typography>Untuk barang:</Typography>
                        <Controller
                            name={`detail.${idx}.itemRepack`}
                            control={methods.control}
                            rules={{
                                required: "Kolom wajib diisi",
                            }}
                            render={({ field, fieldState }) => (
                                <Autocomplete
                                    disablePortal
                                    loading={isLoadingStok}
                                    options={mappedStok ?? []}
                                    getOptionLabel={(option) => option.nama}
                                    isOptionEqualToValue={(option, value) =>
                                        option.id === value.id
                                    }
                                    getOptionDisabled={(option) =>
                                        option.id === product?.id
                                    }
                                    size="small"
                                    value={field.value}
                                    onInputChange={(e) => {
                                        const element =
                                            e.target as HTMLInputElement;
                                        setParamsStok((prev) => ({
                                            ...prev,
                                            search: element.value,
                                        }));
                                    }}
                                    onChange={(
                                        _event,
                                        newKategori: IOptions | null,
                                    ) => {
                                        field.onChange(newKategori);
                                    }}
                                    fullWidth
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Pilih barang"
                                            error={!!fieldState?.error}
                                            helperText={
                                                fieldState?.error &&
                                                "Pilih satu barang"
                                            }
                                        />
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Typography>Harga Beli Satuan:</Typography>
                        <Controller
                            name={`detail.${idx}.hargaBeliRepack`}
                            control={methods.control}
                            rules={{
                                required: "Kolom wajib diisi",
                            }}
                            render={({ field, fieldState }) => (
                                <NumberFormat
                                    disabled
                                    customInput={TextField}
                                    // margin="dense"
                                    size="small"
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    fullWidth
                                    variant="outlined"
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        const valueAkhir = value.replace(
                                            ".",
                                            "",
                                        );
                                        console.log(valueAkhir);
                                        methods.setValue(
                                            `detail.${idx}.hargaBeliRepack`,
                                            Number(valueAkhir),
                                        );
                                    }}
                                    error={!!fieldState?.error}
                                    helperText={
                                        fieldState?.error &&
                                        fieldState?.error.message
                                    }
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography>Rp.</Typography>
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{
                                        "& .MuiOutlinedInput-input.Mui-disabled":
                                            {
                                                color: "rgba(0, 0, 0, 0.87)",
                                                WebkitTextFillColor:
                                                    "rgba(0, 0, 0, 0.87)",
                                            },
                                    }}
                                    {...field}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            )}
            <Grid container spacing={1} marginTop={1}>
                <Grid item xs={12} md={9.5}>
                    <Typography>Keterangan:</Typography>
                    <Controller
                        name={`detail.${idx}.keterangan`}
                        control={methods.control}
                        render={({ field, fieldState }) => (
                            <TextField
                                variant="outlined"
                                placeholder="Keterangan"
                                size="small"
                                id="keterangan"
                                fullWidth
                                multiline
                                rows={3}
                                error={!!fieldState?.error}
                                helperText={
                                    fieldState?.error &&
                                    fieldState?.error.message
                                }
                                {...field}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default BarangTerpilih;
